import React from 'react';
import styled from 'styled-components';

const Bubble = styled.div`
  max-width: 70%;
  padding: 1rem;
  border-radius: 12px;
  margin: 0.5rem;
  background: ${({ sender, isNight }) => {
    if (sender === 'user') {
      return isNight ? '#005eff' : '#d6e4ff';
    } else {
      return isNight ? '#333' : '#eeeeee';
    }
  }};
  color: ${({ sender, isNight }) => {
    if (sender === 'user') {
      return isNight ? '#fff' : '#000';
    } else {
      return isNight ? '#fff' : '#000';
    }
  }};
  align-self: ${({ sender }) => (sender === 'user' ? 'flex-start' : 'flex-end')};
  font-size: 1rem;
  line-height: 1.5;
`;

const MessageBubble = ({ sender, text, isNight }) => (
  <Bubble sender={sender} isNight={isNight}>
    {text}
  </Bubble>
);

export default MessageBubble;
